export const ARRANGEMENT = 'A';
export const CONTINUATION = 'C';
export const RESULTS_LIMIT = 10;
